<template lang="pug">
    transition-group(
        appear,
        class="ib-transition-fade",
        v-bind:css="false",
        @before-enter="beforeEnter",
        @enter="enter",
        @leave="leave")
        slot
</template>

<script>
    /**
     * A fade-in transition group component for fading in lists of items.
     */
    export default {
        name: 'ib-transition-fade',

        props: {
            /**
            * Controls the rate of appearance
            */
            delay: {
                default: 200,
                type: Number
            }
        },

        data() {
            return {
                index: 0
            }
        },

        methods: {
            beforeEnter(el) {
                el.style.transition = 'all 0.35s ease-out';
                el.style.opacity = 0;
            },
            enter(el, done) {
                const delay = this.index * this.delay;
                this.index += 1;
                setTimeout(() => {
                    el.style.opacity = 1;
                }, delay);
            },
            leave(el, done) {
                const delay = this.index * this.delay;
                setTimeout(() => {
                    el.style.opacity = 0;
                    el.style.transition = 'none';
                }, delay);
            }
        }
    }
</script>

<docs>
    ```jsx
        new Vue({
            data() { return {
                numbers: [1]
            }},
            methods: {
                click() {
                    this.numbers.push(this.numbers[this.numbers.length - 1] + 1);
                }
            },
            template: `
                <div>
                    <div v-if="numbers.length > 20">Ok seriously chill out.</div>
                    <div v-if="numbers.length > 10">Ok don't go too crazy.</div>
                    <ib-button @click="click">Click Me</ib-button>
                    <ib-transition-fade>
                        <div v-for="num in numbers" key="num">
                            You are number {{ num }}
                        </div>
                    </ib-transition-fade>
                </div>
            `
        });
    ```
</docs>
